// Great-circle geometry — port of refdata/geo.go for the browser.

const EARTH_RADIUS_KM = 6371;

// distanceKm returns the great-circle distance in kilometres between two
// (lat, lon) points using the haversine formula.
export function distanceKm(lat1, lon1, lat2, lon2) {
  const rlat1 = lat1 * Math.PI / 180;
  const rlat2 = lat2 * Math.PI / 180;
  const dlat = (lat2 - lat1) * Math.PI / 180;
  const dlon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dlat / 2) ** 2 +
            Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(dlon / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

// bearingDeg returns the initial great-circle bearing in degrees (0..360,
// 0=N, 90=E) from point 1 to point 2.
export function bearingDeg(lat1, lon1, lat2, lon2) {
  const rlat1 = lat1 * Math.PI / 180;
  const rlat2 = lat2 * Math.PI / 180;
  const dlon = (lon2 - lon1) * Math.PI / 180;
  const y = Math.sin(dlon) * Math.cos(rlat2);
  const x = Math.cos(rlat1) * Math.sin(rlat2) -
            Math.sin(rlat1) * Math.cos(rlat2) * Math.cos(dlon);
  let b = Math.atan2(y, x) * 180 / Math.PI;
  if (b < 0) b += 360;
  return b;
}
